/**
 * @param props
 */

export default () => {
    return {
        input: null,
        focused: false,
        name: '',
        typing: 0,
        response: null,
        status: null,
        results: [],
        selected: [],
        counter: [],
        mounted() {
            this.input = this.$refs.inputElement;
            this.source = window.variables.complete.suggest;
            this.source = this.source + (this.source.includes("?") ? '&' : '?') + this.input.name + '=';

            this.input.addEventListener('keyup', (e) => {
                e.stopPropagation();

                window.clearTimeout(this.typing);

                if ( 2 <= this.input.value.length) {

                    this.typing = window.setTimeout(() => {

                        fetch(this.source + this.input.value).then((responses) => {
                            return responses.json();
                        }).then((json) => {
                            this.results = json.results;
                            this.counter = json.counter;
                        });
                    }, 250);
                } else {
                    this.reset();
                }

            }, {passive: true});
        },
        reset() {
            this.results = [];
            this.selected = [];
            this.counter = 0;
        },
        select(item) {
            item.checked = true;
            let exists = false;
            Object.entries(this.selected).forEach((value => {
                if ( item.id === value.id ) {
                    exists = true;
                }
            }));
            if(exists === false && this.selected.indexOf(item) === -1) {
                this.selected.push(item);
            }
        },
        deselect(item) {

            this.selected.splice(this.selected.indexOf(item), 1);

            Object.entries(this.results).forEach((value => {
                if ( item.id === value.id ) {
                    value.checked = false;
                }
            }));

        },
        submit() {
            let ids = [];

            Object.values(this.selected).forEach((value => {
                ids.push(value.id);
            }));

            fetch( this.service.video.pornstars.suggest,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: "POST",
                    body: JSON.stringify({ ids: ids })
                })
                .then((data) => {
                    return data.json();
                })
                .then((data) => {
                    this.status = data;
                    this.results = [];
                    this.selected = [];
                    this.name = '';
                });

        }



    }
};
